import { h, render } from 'preact'
import HoverImage from './hover-image'
import InfoWindow from './info-window'

const ServiceStationMarker = (props) => {
    return (
        <div
            class={`${  props.active ? 'nm-active' : '' }`}
            style={{
                position: 'absolute',
                width: '54px',
                height: '70px',
                left: '-27px',
                top: '-70px'
        }}>
            <HoverImage
                src={ `${props.active ? 'marker-estacion-active.png' : 'marker-estacion.png'}` }
                hoverSrc={ 'marker-estacion-active.png' }
                onClick={ props.active ?  props.clearActiveMarker : props.setActiveMarker }
            />
            { props.active &&
                <InfoWindow close={props.clearActiveMarker} {...props} />
            }
        </div>
    )
}

export default ServiceStationMarker
